import { Log, Registry } from '@lightningjs/sdk'
import ExpandableTileLandscape from './ExpandableTileLandscape'
import VastParser from '../../../vast-parser'
import { getFetchUrl } from '../../../models/data-service'

export default class GridBannerTile extends ExpandableTileLandscape {
    private _rotationTimer: any = null
    private _midpointTimer: any = null
    private _trackerStatus = { start: false, midpoint: false, complete: false }

    loadGridBannerCreative = async () => {
        const itemNode = this._itemNode
        const res = await VastParser.fetchWithTimeout(getFetchUrl(itemNode.gridBannerAdUrl))
        const actualAd = await res.json()
        if (!itemNode || actualAd?.info === undefined) return
        const variant = VastParser.selectCreativeVariant(actualAd.info)
        if (!variant) return
        const duration = parseInt(actualAd.info.duration) || itemNode.gridBannerDuration
        const creativeData = VastParser.buildCreativeData(variant.raw, variant.refWidth, variant.refHeight, duration)
        itemNode.main_picture = creativeData.url
        itemNode.gridBannerDuration = duration
        itemNode.gridBannerStatus = 'ready'
        this._updateBannerImage()
    }

    _updateBannerImage() {
        this.imgSrc = this._itemNode.main_picture
    }

    override _active() {
        if (this._itemNode && this._itemNode.gridBannerStatus === 'pending') {
            this.loadGridBannerCreative()
        } else if(this._itemNode && this._itemNode.gridBannerStatus === 'ready') {
            this._updateBannerImage()
        }
    }


    override _focus() {
        super._focus()
        this.tag('Stroke').shader.strokeColor = 0x00000000
        this.tag('Wrapper').smooth = { scale: 1.03 }
        this._trackerStatus = { start: false, midpoint: false, complete: false }
        this._startRotation()
    }

    override _unfocus() {
        super._unfocus()
        this.tag('Wrapper').smooth = { scale: 1 }
        this._stopRotation()
    }

    override _detach() {
        this._stopRotation()
        super._detach()
    }

    private _startRotation() {
        this._stopRotation()
        this._fireImpression()
        this._fireTracker('start')
        const durationMs = (this._itemNode?.gridBannerDuration || 8) * 1000
        this._midpointTimer = Registry.setTimeout(() => {
            this._midpointTimer = null
            this._fireTracker('midpoint')
        }, durationMs / 2)
        this._rotationTimer = Registry.setTimeout(() => {
            this._rotationTimer = null
            this._fireTracker('complete')
            this.fireAncestors('$gridBannerRotate')
        }, durationMs)
    }

    private _stopRotation() {
        if (this._rotationTimer) {
            Registry.clearTimeout(this._rotationTimer)
            this._rotationTimer = null
        }
        if (this._midpointTimer) {
            Registry.clearTimeout(this._midpointTimer)
            this._midpointTimer = null
        }
    }

    private _fireImpression() {
        const url = this._itemNode?.gridBannerImpressionUrl
        if (!url) return
        fetch(url).catch(() => {
            Log.info('adlog', 'GridBannerTile: impression tracker failed', url)
        })
    }

    private _fireTracker(event: 'start' | 'midpoint' | 'complete') {
        if (this._trackerStatus[event]) return
        this._trackerStatus[event] = true
        const url = this._itemNode?.gridBannerTrackers?.[event]
        if (!url) return
        fetch(url).catch(() => {
            Log.info('adlog', 'GridBannerTile: ' + event + ' tracker failed', url)
        })
    }

    override _handleClick() {
        return false
    }
}
